import styled, { css } from 'styled-components';

import { scrollStyle, takeColor } from 'theme/tools';

import { Container as ContainerBox } from 'components/Box/styles';

export const StrongLabel = styled.strong`
  color: ${takeColor('black')};
  font-size: 18px;
  font-weight: 600;
`;

interface ISelectWrapper {
  isCompleted?: boolean;
  isFocus?: boolean;
  isValue?: boolean;
}

interface IWrapperOptions {
  maxHeight?: string;
}

export const WrapperOptions = styled(ContainerBox)<IWrapperOptions>`
  top: 70px;
  left: 0;
  position: absolute;
  width: 100%;
  height: fit-content;
  padding: 30px;
  display: flex;
  flex-direction: column;
  transition: 0.2s all;
  opacity: 0;
  visibility: hidden;
  cursor: initial;
  background-color: ${takeColor('white')};
  max-height: ${({ maxHeight = '235px' }: IWrapperOptions) => maxHeight};
  z-index: 9;
` as any;

export const SelectWrapper = styled('div')<ISelectWrapper>`
  position: relative;
  cursor: ${props => (!props.isValue ? 'pointer' : 'initial')};

  strong {
    flex: 1;
    color: ${takeColor('grayLightText')};
    transition: 0.2s all;
  }

  svg {
    transition: 0.2s all;
    transform: rotate(180deg);
  }

  &:hover {
    strong {
      color: ${takeColor('black')};
    }

    * {
      fill: ${takeColor('black')};
    }
  }

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      svg {
        * {
          fill: ${takeColor('grayMedium')};
        }
      }

      strong {
        color: ${takeColor('grayMedium')};
      }
    `};

  ${({ isFocus }) =>
    isFocus &&
    css`
      svg {
        transform: rotate(0deg);

        * {
          fill: ${takeColor('black')};
        }
      }

      strong {
        color: ${takeColor('black')};
      }

      ${WrapperOptions} {
        opacity: 1;
        visibility: visible;
        top: 80px;
      }
    `};
`;

export const WrapperLeftContent = styled.div`
  margin-right: 12px;
`;

interface IOption {
  isSelected?: boolean;
}

export const SelectItem = styled('div')<IOption>`
  cursor: pointer;
  color: ${takeColor('grayLightText')};
  transition: color 0.2s;
  font-size: 13px;
  padding: 7.5px 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &:hover {
    color: ${takeColor('black')};
    font-weight: 600;
  }

  ${({ isSelected }: IOption) =>
    isSelected &&
    css`
      color: ${takeColor('black')};
      font-weight: 600;
    `}
`;

export const SelectInputSearchStyles = styled.input`
  background-color: ${takeColor('grayInputSearch')};
  border-radius: 100px;
  width: 100%;
  border: 0;
  font-size: 11px;
  padding: 10px 20px;
  margin-bottom: 20px;
  color: ${takeColor('grayMedium')};

  ::placeholder {
    color: ${takeColor('grayLightText')};
  }
`;

export const InsivibleDivClick = styled.div`
  position: absolute;
  left: 0;
  top: -40px;
  width: 100%;
  height: 140px;
`;

export const BoxChips = styled.div`
  float: left;
  max-height: 100px;
  overflow-y: scroll;
  margin-right: 5px;
  border-radius: 10px;
  z-index: 9999;

  ${scrollStyle}
`;

export const BoxIcon = styled.div`
  cursor: pointer;
`;
